import React from 'react';
import { Container, Row } from 'react-bootstrap';
import { ImageList, ImageListItem, ImageListItemBar } from '@mui/material';
import { createImageViewerButton, createImageViewer } from '../../helpers/imageViewerHelpers';
import one from '../../Assets/GraphicStorytelling/1.jpg';
import two from '../../Assets/GraphicStorytelling/2.jpg';
import three from '../../Assets/GraphicStorytelling/3.jpg';
import four from '../../Assets/GraphicStorytelling/4.jpg';
import five from '../../Assets/GraphicStorytelling/5.jpg';
import six from '../../Assets/GraphicStorytelling/6.jpg';
import seven from '../../Assets/GraphicStorytelling/7.jpg';
import eight from '../../Assets/GraphicStorytelling/8.jpg';
import nine from '../../Assets/GraphicStorytelling/9.jpg';
import ten from '../../Assets/GraphicStorytelling/10.jpg';
import eleven from '../../Assets/GraphicStorytelling/11.jpg';
import twelve from '../../Assets/GraphicStorytelling/12.jpg';
import thirteen from '../../Assets/GraphicStorytelling/13.jpg';
import fourteen from '../../Assets/GraphicStorytelling/14.jpg';
import fifteen from '../../Assets/GraphicStorytelling/15.jpg';
import sixteen from '../../Assets/GraphicStorytelling/16.jpg';

// Data structure for graphic storytelling artwork
const graphicStorytellingData = [
  { img: one, title: 'Graphic Story Page 1', author: 'Nikoletta' },
  { img: two, title: 'Graphic Story Page 2', author: 'Nikoletta' },
  { img: three, title: 'Graphic Story Page 3', author: 'Nikoletta' },
  { img: four, title: 'Graphic Story Page 4', author: 'Nikoletta' },
  { img: five, title: 'Graphic Story Page 5', author: 'Nikoletta' },
  { img: six, title: 'Graphic Story Page 6', author: 'Nikoletta' },
  { img: seven, title: 'Graphic Story Page 7', author: 'Nikoletta' },
  { img: eight, title: 'Graphic Story Page 8', author: 'Nikoletta' },
  { img: nine, title: 'Graphic Story Page 9', author: 'Nikoletta' },
  { img: ten, title: 'Graphic Story Page 10', author: 'Nikoletta' },
  { img: eleven, title: 'Graphic Story Page 11', author: 'Nikoletta' },
  { img: twelve, title: 'Graphic Story Page 12', author: 'Nikoletta' },
  { img: thirteen, title: 'Graphic Story Page 13', author: 'Nikoletta' },
  { img: fourteen, title: 'Graphic Story Page 14', author: 'Nikoletta' },
  { img: fifteen, title: 'Graphic Story Page 15', author: 'Nikoletta' },
  { img: sixteen, title: 'Graphic Story Page 16', author: 'Nikoletta' },
];

function GraphicStorytelling() {
  // Image viewer state
  const [currentImage, setCurrentImage] = React.useState(0);
  const [isViewerOpen, setIsViewerOpen] = React.useState(false);

  // Image array for the viewer (just the image sources)
  const graphicImages = [
    one,
    two,
    three,
    four,
    five,
    six,
    seven,
    eight,
    nine,
    ten,
    eleven,
    twelve,
    thirteen,
    fourteen,
    fifteen,
    sixteen,
  ];

  // Image viewer handlers
  const openImageViewer = React.useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          <strong className="text-accent">Graphic Storytelling</strong>
        </h1>
        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }} />
      </Container>

      <ImageList
        variant="masonry"
        cols={2}
        gap={20}
        sx={{
          '@media (max-width: 600px)': {
            columnCount: 1,
          },
        }}
      >
        {graphicStorytellingData.map((src, index) => (
          <ImageListItem key={src.img}>
            {createImageViewerButton({
              index,
              src,
              onImageClick: openImageViewer,
              characterType: 'graphic storytelling page'
            })}
            <ImageListItemBar
              title={src.title}
              subtitle={<span>by: {src.author}</span>}
              position="below"
              sx={{
                background: 'none',
                '& .MuiImageListItemBar-title': {
                  color: '#333',
                  fontSize: '0.9rem',
                  fontWeight: 600,
                },
                '& .MuiImageListItemBar-subtitle': {
                  color: '#666',
                  fontSize: '0.8rem',
                },
              }}
            />
          </ImageListItem>
        ))}
      </ImageList>

      {createImageViewer({
        isOpen: isViewerOpen,
        images: graphicImages,
        currentIndex: currentImage,
        onClose: closeImageViewer,
      })}
    </Container>
  );
}

export default GraphicStorytelling;
